import React from 'react';

/**
 * Split a text on sentence boundaries and render each sentence on its own line.
 * Useful to make summaries more readable per user requirement.
 */
export function Sentences({ text, className = '' }) {
  if (!text) return null;
  // Split on ". " or ".\n" but keep the period attached
  const parts = String(text)
    .replace(/\n+/g, ' ')
    .split(/(?<=[\.\!\?])\s+(?=[A-ZÀ-ÚÉÈÊÎÏÔÙŒ«"])/)
    .map(s => s.trim())
    .filter(Boolean);
  if (parts.length <= 1) return <span className={className}>{text}</span>;
  // Use <span> + <br/> so the component is valid inside <p>, <div> or <span>.
  return (
    <span className={className}>
      {parts.map((p, i) => (
        <React.Fragment key={i}>
          {i > 0 && <br />}
          <span>{p}</span>
        </React.Fragment>
      ))}
    </span>
  );
}

/**
 * Helper to trigger a download from a URL.
 * If same-origin, browser download attribute works.
 * For cross-origin (war.gov, navair.mil), opens in new tab — user can then save.
 */
export function downloadUrl(url, suggestedName) {
  if (!url) return;
  const a = document.createElement('a');
  a.href = url;
  if (suggestedName) a.download = suggestedName;
  a.target = '_blank';
  a.rel = 'noreferrer noopener';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}
